"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogPortal: function() {
        return DialogPortal;
    },
    DropdownMenu: function() {
        return DropdownMenu;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _reactdom = require("react-dom");
const _Dropdown = require("../Dropdown");
const _Theme = require("../../../contexts/Theme");
const _ModalContext = require("../../Modal/ModalContext");
const _AdminButton = require("../../Button/AdminButton");
const _Text = require("../../Text/Text");
const _hooks = require("../../../hooks");
const _BodyPortal = require("../../BodyPortal/BodyPortal");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
// Intersection Ratio how much element visible before
// we hide.
const intersectionRatioThreshold = 0.25;
const DialogPortal = (param)=>{
    let { children } = param;
    const { modalBodyRef } = (0, _react.useContext)(_ModalContext.ModalContext);
    if ((modalBodyRef === null || modalBodyRef === void 0 ? void 0 : modalBodyRef.current) == null || typeof document === "undefined") {
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, children);
    }
    const dialog = modalBodyRef.current.closest("[role='dialog']");
    if (dialog == null) {
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, children);
    }
    return /*#__PURE__*/ (0, _reactdom.createPortal)(children, dialog);
};
const DropdownMenu = (param)=>{
    let { children, fixedHeader, width, title, mobileView, maxHeight, portalType, isNested = false } = param;
    const isMobileWidth = (0, _hooks.useIsMobileWidth)();
    const { show, floating, x, y, strategy, toggleId, setShow, refs } = (0, _react.useContext)(_Dropdown.DropdownContext);
    const { spacers, colors, borderRadius, zIndexes, breakpoints } = (0, _Theme.useTheme)();
    const { modalBodyRef } = (0, _react.useContext)(_ModalContext.ModalContext);
    const isMobile = (0, _react.useMemo)(()=>{
        return mobileView != null && isMobileWidth;
    }, [
        isMobileWidth,
        mobileView
    ]);
    (0, _react.useEffect)(()=>{
        // focus first input element for mobile
        if (isMobile && show && refs.floating.current != null) {
            var _refs_floating_current_querySelector;
            (_refs_floating_current_querySelector = refs.floating.current.querySelector("input")) === null || _refs_floating_current_querySelector === void 0 ? void 0 : _refs_floating_current_querySelector.focus();
        }
    }, [
        isMobile,
        show,
        refs
    ]);
    (0, _react.useEffect)(()=>{
        // hide body scroll for full overlays
        if (isMobile && mobileView === "full") {
            document.body.style.overflow = show ? "hidden" : "";
        }
    }, [
        isMobile,
        show,
        mobileView
    ]);
    (0, _react.useEffect)(()=>{
        if (isMobile || (modalBodyRef === null || modalBodyRef === void 0 ? void 0 : modalBodyRef.current) == null || refs.reference.current == null || !show) {
            return undefined;
        }
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].intersectionRatio <= intersectionRatioThreshold) {
                setShow(false);
            }
        }, {
            threshold: intersectionRatioThreshold
        });
        observer.observe(refs.reference.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isMobile,
        modalBodyRef,
        refs.reference,
        setShow,
        show
    ]);
    const handleDone = ()=>{
        setTimeout(()=>{
            setShow(false);
        }, 0);
    };
    const sectionClassName = (0, _react.useMemo)(()=>{
        if (isMobile) {
            if (mobileView === "full") {
                return "section-mobile section-mobile--full";
            }
            return "section-mobile";
        }
        return undefined;
    }, [
        isMobile,
        mobileView
    ]);
    const Portal = (0, _react.useMemo)(()=>{
        if (portalType === "body") {
            return _BodyPortal.BodyPortal;
        }
        return DialogPortal;
    }, [
        portalType
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, show && /*#__PURE__*/ _react.default.createElement(Portal, {
        className: _style.default.dynamic([
            [
                "e427c350da0172d5",
                [
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    width !== undefined ? "auto" : "18rem",
                    width !== undefined ? "".concat(width, "px") : "auto",
                    zIndexes.dropdown,
                    strategy,
                    (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
                    x !== null && x !== void 0 ? x : 0,
                    spacers.s2,
                    spacers.s3,
                    maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
                    breakpoints.lg,
                    zIndexes.dropdown - 1,
                    colors.transparent.black[40],
                    colors.transparent.black[10],
                    colors.grayscale[60]
                ]
            ]
        ])
    }, isMobile && /*#__PURE__*/ _react.default.createElement("div", {
        onClick: handleDone,
        className: _style.default.dynamic([
            [
                "e427c350da0172d5",
                [
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    width !== undefined ? "auto" : "18rem",
                    width !== undefined ? "".concat(width, "px") : "auto",
                    zIndexes.dropdown,
                    strategy,
                    (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
                    x !== null && x !== void 0 ? x : 0,
                    spacers.s2,
                    spacers.s3,
                    maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
                    breakpoints.lg,
                    zIndexes.dropdown - 1,
                    colors.transparent.black[40],
                    colors.transparent.black[10],
                    colors.grayscale[60]
                ]
            ]
        ]) + " " + "dropdown-backdrop-mobile"
    }), /*#__PURE__*/ _react.default.createElement("section", {
        ref: floating,
        role: "listbox",
        "aria-labelledby": toggleId,
        "data-escape-focus-trap": true,
        className: _style.default.dynamic([
            [
                "e427c350da0172d5",
                [
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    width !== undefined ? "auto" : "18rem",
                    width !== undefined ? "".concat(width, "px") : "auto",
                    zIndexes.dropdown,
                    strategy,
                    (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
                    x !== null && x !== void 0 ? x : 0,
                    spacers.s2,
                    spacers.s3,
                    maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
                    breakpoints.lg,
                    zIndexes.dropdown - 1,
                    colors.transparent.black[40],
                    colors.transparent.black[10],
                    colors.grayscale[60]
                ]
            ]
        ]) + " " + (sectionClassName || "")
    }, fixedHeader, isMobile && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "e427c350da0172d5",
                [
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    width !== undefined ? "auto" : "18rem",
                    width !== undefined ? "".concat(width, "px") : "auto",
                    zIndexes.dropdown,
                    strategy,
                    (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
                    x !== null && x !== void 0 ? x : 0,
                    spacers.s2,
                    spacers.s3,
                    maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
                    breakpoints.lg,
                    zIndexes.dropdown - 1,
                    colors.transparent.black[40],
                    colors.transparent.black[10],
                    colors.grayscale[60]
                ]
            ]
        ]) + " " + "header-mobile ".concat(title == null && "header-mobile--short")
    }, mobileView !== "minimal" && /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "ghost",
        onClick: handleDone,
        className: "done-button-mobile"
    }, "Done"), title != null && /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "button",
        size: "small"
    }, title)), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "e427c350da0172d5",
                [
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    width !== undefined ? "auto" : "18rem",
                    width !== undefined ? "".concat(width, "px") : "auto",
                    zIndexes.dropdown,
                    strategy,
                    (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
                    x !== null && x !== void 0 ? x : 0,
                    spacers.s2,
                    spacers.s3,
                    maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
                    breakpoints.lg,
                    zIndexes.dropdown - 1,
                    colors.transparent.black[40],
                    colors.transparent.black[10],
                    colors.grayscale[60]
                ]
            ]
        ]) + " " + "content"
    }, children))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "e427c350da0172d5",
        dynamic: [
            colors.white,
            colors.border,
            borderRadius,
            colors.dark,
            width !== undefined ? "auto" : "18rem",
            width !== undefined ? "".concat(width, "px") : "auto",
            zIndexes.dropdown,
            strategy,
            (y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0),
            x !== null && x !== void 0 ? x : 0,
            spacers.s2,
            spacers.s3,
            maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200,
            breakpoints.lg,
            zIndexes.dropdown - 1,
            colors.transparent.black[40],
            colors.transparent.black[10],
            colors.grayscale[60]
        ]
    }, "section.__jsx-style-dynamic-selector{background:".concat(colors.white, ";border:1px solid ").concat(colors.border, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";color:").concat(colors.dark, ";max-width:").concat(width !== undefined ? "auto" : "18rem", ";width:").concat(width !== undefined ? "".concat(width, "px") : "auto", ";z-index:").concat(zIndexes.dropdown, ";position:").concat(strategy, ";top:").concat((y !== null && y !== void 0 ? y : 0) + (isNested && !isMobile ? -4 : 0), "px;left:").concat(x !== null && x !== void 0 ? x : 0, "px;-webkit-box-shadow:0 4px 8px rgba(0,0,0,.1);-moz-box-shadow:0 4px 8px rgba(0,0,0,.1);box-shadow:0 4px 8px rgba(0,0,0,.1);margin-top:").concat(spacers.s2, ";padding:").concat(spacers.s3, " 0}.content.__jsx-style-dynamic-selector{overflow-y:auto;max-height:").concat(maxHeight !== null && maxHeight !== void 0 ? maxHeight : 200, "px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.content.__jsx-style-dynamic-selector button{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin:0 8px}@media(max-width:").concat(breakpoints.lg, "px){.section-mobile.__jsx-style-dynamic-selector{-webkit-border-top-left-radius:8px;-moz-border-radius-topleft:8px;border-top-left-radius:8px;-webkit-border-top-right-radius:8px;-moz-border-radius-topright:8px;border-top-right-radius:8px;-webkit-border-bottom-left-radius:0px;-moz-border-radius-bottomleft:0px;border-bottom-left-radius:0px;-webkit-border-bottom-right-radius:0px;-moz-border-radius-bottomright:0px;border-bottom-right-radius:0px;width:100%;max-width:unset;position:fixed;bottom:0px;right:0px;left:0px;top:unset;padding:12px 0 16px 0}.section-mobile--full.__jsx-style-dynamic-selector{top:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;margin:0}.section-mobile.__jsx-style-dynamic-selector .content.__jsx-style-dynamic-selector{max-height:-webkit-calc(100vh - 56px);max-height:-moz-calc(100vh - 56px);max-height:calc(100vh - 56px);padding:8px;padding-bottom:0px}.section-mobile--full.__jsx-style-dynamic-selector .content.__jsx-style-dynamic-selector{padding-bottom:8px}.dropdown-backdrop-mobile.__jsx-style-dynamic-selector{position:fixed;top:0;right:0;bottom:0;left:0;z-index:").concat(zIndexes.dropdown - 1, ";background-color:").concat(colors.transparent.black[40], "}.header-mobile.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;padding:12px 12px 16px;border-bottom:1px solid ").concat(colors.transparent.black[10], ";color:").concat(colors.grayscale[60], "}.header-mobile--short.__jsx-style-dynamic-selector{-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:0;padding-bottom:0;border:0}.section-mobile .header-mobile.__jsx-style-dynamic-selector .done-button-mobile{position:absolute;top:16px;right:12px;z-index:1}}")));
};
DropdownMenu.displayName = "DropdownMenu";

//# sourceMappingURL=DropdownMenu.js.map